import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  id: "js-shortCalculation",
  class: "premium-box table-responsive premium-second-under premium-calculator-block__block-card block-card block-card--bg-light-grey"
}
const _hoisted_2 = { class: "block-card__content" }
const _hoisted_3 = { class: "table" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { key: 3 }
const _hoisted_8 = { class: "table" }

import { usePremCalcStore } from "@premcalc/store/premCalcStore";
import GuaranteeModal from "@premcalc/components/calculations/guaranteeModal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'shortCalculation',
  setup(__props) {

const store = usePremCalcStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", _hoisted_3, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", null, _toDisplayString(_unref(store).translations?.shortTable?.headingGuarType), 1 /* TEXT */),
            _createElementVNode("th", null, _toDisplayString(_unref(store).translations?.shortTable?.headingPct), 1 /* TEXT */)
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_unref(store).shortCalculation?.centralBankRateValue)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_4, [
                _createElementVNode("td", null, _toDisplayString(_unref(store).translations?.shortTable?.headingPct), 1 /* TEXT */),
                _createElementVNode("td", null, _toDisplayString(_unref(store).shortCalculation?.centralBankRateValue), 1 /* TEXT */)
              ]))
            : _createCommentVNode("v-if", true),
          (_unref(store).shortCalculation?.otherPublicBuyerRateValue)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_5, [
                _createElementVNode("td", null, _toDisplayString(_unref(store).translations?.shortTable?.guarTypeOtherBank), 1 /* TEXT */),
                _createElementVNode("td", null, _toDisplayString(_unref(store).shortCalculation?.otherPublicBuyerRateValue), 1 /* TEXT */)
              ]))
            : _createCommentVNode("v-if", true),
          (_unref(store)?.shortCalculation?.largeCompanyOrBankRateValue)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_6, [
                _createElementVNode("td", null, _toDisplayString(_unref(store).translations?.shortTable?.guarTypeLargeCompany), 1 /* TEXT */),
                _createElementVNode("td", null, _toDisplayString(_unref(store)?.shortCalculation?.largeCompanyOrBankRateValue), 1 /* TEXT */)
              ]))
            : _createCommentVNode("v-if", true),
          (_unref(store).shortCalculation?.smallCompanyOrBankRateValue)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
                _createElementVNode("td", null, _toDisplayString(_unref(store).translations?.shortTable?.guarTypeSmallCompany), 1 /* TEXT */),
                _createElementVNode("td", null, _toDisplayString(_unref(store).shortCalculation?.smallCompanyOrBankRateValue), 1 /* TEXT */)
              ]))
            : _createCommentVNode("v-if", true)
        ])
      ]),
      _createElementVNode("table", _hoisted_8, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", null, _toDisplayString(_unref(store).translations?.guarPctTable?.headingType), 1 /* TEXT */),
            _createElementVNode("th", null, _toDisplayString(_unref(store).translations?.guarPctTable?.headingNumbers), 1 /* TEXT */)
          ])
        ]),
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", null, _toDisplayString(_unref(store).translations?.guarPctTable?.headingCentralBank), 1 /* TEXT */),
            _createElementVNode("td", null, _toDisplayString(_unref(store).shortCalculation?.guaranteePctCentralBank), 1 /* TEXT */)
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", null, _toDisplayString(_unref(store).translations?.guarPctTable?.headingOther), 1 /* TEXT */),
            _createElementVNode("td", null, _toDisplayString(_unref(store).shortCalculation?.guaranteePctOtherBuyers), 1 /* TEXT */)
          ])
        ])
      ]),
      _createVNode(GuaranteeModal)
    ])
  ]))
}
}

})